import React from "react";
import TestimonialCard from "./TestimonialCard";
import "./TestimonialCardGrid.css";

export default function TestimonialCardGrid({ testimonials }) {
  return (
    <div className="testimonial-card-grid">
      {testimonials.map((t, i) => (
        <TestimonialCard key={i} {...t} />
      ))}
    </div>
  );
}
